import { Component } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { PdfService } from '../pdf.service';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheet } from '../bottom.sheet';
import { Platform } from '@angular/cdk/platform';
import { Camera,CameraOptions } from '@ionic-native/camera/ngx';
import { DomSanitizer } from '@angular/platform-browser';
let k=1;
@Component({
  selector: 'app-monthly-tracker',
  templateUrl: './monthly-tracker.component.html',
  styleUrls: ['./monthly-tracker.component.scss'],
})
export class MonthlyTrackerComponent {
  enddate;
  nBlob:any;
  popImg:any;
  tDate;
  fDate;
  startdate;
  serviceInc:boolean;
  pName;
  reasons;
  pColor;
  pMake;
  orgId;
  pModel;
  spName;
  filter:boolean ;
  pIdentity;
  items:any=[]; 
  dummyItems:any=[];
  cloneUsers:any=[]; 
  custName;
  userData;
  userCheck;
  category;
  flatName;
  loader:boolean=true;
  dt = new Date(); 
  dateFormat;
  status;
  cateName = "CAR CARE SERVICES";
  contName = "SELECT";
  cateId = 21;
  trackerObj=[];
  notifyItems: any = [];
  send: boolean = false;
  check: boolean = false;
  close:boolean = false;
  filterLength;
  search:any=[];
  clickedImage:any;
  text:boolean;
  days=['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  actionObj=[{ name: "Missed", id: '1'},{ name: "Not In Place", id: '2'},{ name: "Completed", id: '3'},{ name: "Request For Change", id: '4'}];
  actionId;
  actionName;
  Type;
  options: CameraOptions = {
    quality: 30,
    destinationType: this.camera.DestinationType.DATA_URL,
    encodingType: this.camera.EncodingType.JPEG,
    mediaType: this.camera.MediaType.PICTURE
  }
  imgView:boolean = false;
  missedCheck:boolean = false;
missedValue;
missedId;
resId;
ChangeInc:boolean = false;
changeId;
missedData:any=[];
dubTrackObj:any=[];
conId;
array:any=[]
mbv:boolean;
count;
ContractorName;
contractors;
contractorId;
id;
filterPop;
cate1Id;
start;
  constructor(private service: ApiService,
    public handler: HandlerService,
    public pdf: PdfService,
    public router: Router,
    private camera: Camera,
    public auth: AuthService,private bottomSheet: MatBottomSheet, 
    private platform: Platform,public sanitizer: DomSanitizer) { }

    ionViewWillEnter(){
      sessionStorage.setItem('vendorApp','true');
      this.trackerObj=[];
      this.notifyItems=[];
      this.orgId=localStorage.getItem('organizationId')
      this.conId = localStorage.getItem('currentUserId')
      this.loader=true;
      if (this.platform.ANDROID || this.platform.IOS){
        this.text=true;
        this.mbv=false;
      }else{
       this.text=false;
       this.mbv=true;

      }
      this.getCategory();
      var date = new Date();
      this.dateFormat = this.auth.getDateformat();
      this.startdate = new Date(date.getFullYear(), date.getMonth(), 1);
      this.enddate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.getSubscription();
      this.getDailyStatus();
      this.getMissedStaticData();
      this.getChange();
      this.getsc1();
    }

    getCategory() {
      this.service.getOrgCategory().subscribe((res: any) => {
        this.category = res;       
      })
    }


    getSubscription(){
      // this.loader=true;
      var start = this.returnDate(this.startdate) + ' ' + '00:00:00';
      var end = this.returnDate(this.enddate) + ' ' + '23:59:59';
      this.cateId=21;  
      if(this.auth.checkCapability('FSA')){
        this.service.getServiceTrackerCount(this.cateId,start,end).subscribe((res:any)=>{
          this.count =res;
        })
        k=1; 
        this.service.monthlyTrackerByPage(this.cateId,start,end,k).subscribe((res:any)=>{
    
          if(res){
            this.items = res;
            this.items.map(res=>{
              this.trackerObj.push(res.singleServicesTracker)
            })         
            this.trackerObj.map(res1=>{
             Object.assign(res1,{clicked: false,cusName:res1[0].custName,packId:res1[0].packageId,packName:res1[0].packageName,street:res1[0].street,flatName:res1[0].flatName})
             res1.map(res2=>{
              res2.serviceTracker.sort((a, b) => new Date(a.apptDate).getTime() - new Date(b.apptDate).getTime());
            })
            })
            this.dubTrackObj = this.trackerObj;
            this.dummyItems = this.trackerObj;
        
            k++;        
           setTimeout(() => {
            this.loader=false;
           }, 5000);
           
          }else{
            this.trackerObj=[];
            this.loader=false;
            this.handler.res('No Data Found')
          }
          },
        err=>{
          this.loader = false;
          this.handler.err(err)
        })
      } 
      if(this.auth.checkCapability('SP') && !this.auth.checkCapability('FSA')){   
       k=1;
       this.service.getServiceTrackerCountByOrg(this.cateId,this.orgId,start,end).subscribe((res:any)=>{
        this.count =res;
      })
        this.service.monthlyTrackerOtherOrgBypage(this.cateId,this.orgId,start,end,k).subscribe((res:any)=>{
          if(res){
            this.items = res;
            this.items.map(res=>{
              this.trackerObj.push(res.singleServicesTracker)
            })
            this.trackerObj.map(res1=>{
             Object.assign(res1,{clicked: false,cusName:res1[0].custName,packId:res1[0].packageId,packName:res1[0].packageName,street:res1[0].street,flatName:res1[0].flatName})
             res1.map(res2=>{
              res2.serviceTracker.sort((a, b) => new Date(a.apptDate).getTime() - new Date(b.apptDate).getTime());
            })
            })
            this.dubTrackObj = this.trackerObj;
            this.dummyItems = this.trackerObj;
            k++;        
           setTimeout(() => {
            this.loader=false;
           }, 5000);
          }else{
            this.trackerObj=[];
            this.loader=false;
            this.handler.res('No Data Found')
          }
 
         
        },err=>{
          this.loader = false;
          this.handler.err(err)
        }) 
      }
      if(this.auth.checkCapability('SC') && !this.auth.checkCapability('SP') && !this.auth.checkCapability('FSA')){   
        k=1;
        this.service.getServiceTrackerCountByCon(this.cateId,this.conId,start,end).subscribe((res:any)=>{
          this.count =res;
        })
        this.service.monthlyTrackerConBypage(this.cateId,this.conId,start,end,k).subscribe((res:any)=>{
          if(res){
            this.items = res;
            this.items.map(res=>{
              this.trackerObj.push(res.singleServicesTracker)
            })
            this.trackerObj.map(res1=>{
             Object.assign(res1,{clicked: false,cusName:res1[0].custName,packId:res1[0].packageId,packName:res1[0].packageName,street:res1[0].street,flatName:res1[0].flatName})
             res1.map(res2=>{
              res2.serviceTracker.sort((a, b) => new Date(a.apptDate).getTime() - new Date(b.apptDate).getTime());
            })
            })
            this.dubTrackObj = this.trackerObj;
            this.dummyItems = this.trackerObj;
            k++;        
           setTimeout(() => {
            this.loader=false;
           }, 5000);
          }else{
            this.trackerObj=[];
            this.loader=false;
            this.handler.res('No Data Found')
          }
 
         
        },err=>{
          this.loader = false;
          this.handler.err(err)
        })   
      }
    
    }
    
    getCusData(data){
      this.userData = data;
      this.userCheck=true;
    }


    returnDate1(data){
      if(data.apptDate){
        var x  = data.apptDate.split("T");
        var y = x[0].split("-");
        var z = y[2]
        return z
      }
    }

    getDayName(data){
      var d = new Date(data.apptDate);
      var dayName = this.days[d.getDay()];
      return dayName
    }

  startDate(){
   this.fDate=this.returnDate(this.startdate);
  }

  endDate(){
    // this.loader = true;
    // this.custName="";
    // var start = this.returnDate(this.startdate) + ' ' + '00:00:00';
    // var end = this.returnDate(this.enddate) + ' ' + '23:59:59'; 
    // this.trackerObj=[];
    // if(this.auth.checkCapability('FSA')){
    //   k=1;
    //   this.service.getServiceTrackerCount(this.cateId,start,end).subscribe((res:any)=>{
    //     this.count =res;
    //   })
    //   this.service.monthlyTrackerByPage(this.cateId,start,end,k).subscribe((res:any)=>{
    //     if(res){
    //       this.items = res;
    //       this.items.map(res=>{
    //         this.trackerObj.push(res.singleServicesTracker)
    //       })         
    //       this.trackerObj.map(res1=>{
    //        Object.assign(res1,{clicked: false,cusName:res1[0].custName,packId:res1[0].packageId,street:res1[0].street,flatName:res1[0].flatName})
    //        res1.map(res2=>{
    //         res2.serviceTracker.sort((a, b) => new Date(a.apptDate).getTime() - new Date(b.apptDate).getTime());
    //       })
    //       })
    //       this.dubTrackObj = this.trackerObj;        
    //       k++;        
    //      setTimeout(() => {
    //       this.loader=false;
    //      }, 5000);
         
    //     }else{
    //       this.trackerObj=[];
    //       this.loader=false;
    //       this.handler.res('No Data Found')
    //     }
    //     },
    //   err=>{
    //     this.loader = false;
    //     this.handler.err(err)
    //   })
    // } 
    // if(this.auth.checkCapability('SP') && !this.auth.checkCapability('FSA')){
    //   k=1;
    //   this.service.getServiceTrackerCountByOrg(this.cateId,this.orgId,start,end).subscribe((res:any)=>{
    //     this.count =res;
    //   })
    //   this.service.monthlyTrackerOtherOrgBypage(this.cateId,this.orgId,start,end,k).subscribe((res:any)=>{
    //     if(res){
    //       this.items = res;
    //       this.items.map(res=>{
    //         this.trackerObj.push(res.singleServicesTracker)
    //       })
    //       this.trackerObj.map(res1=>{
    //        Object.assign(res1,{clicked: false,cusName:res1[0].custName,packId:res1[0].packageId,street:res1[0].street,flatName:res1[0].flatName})
    //        res1.map(res2=>{
    //         res2.serviceTracker.sort((a, b) => new Date(a.apptDate).getTime() - new Date(b.apptDate).getTime());
    //       })
    //       })
    //       this.dubTrackObj = this.trackerObj;     
    //       k++;        
    //      setTimeout(() => {
    //       this.loader=false;
    //      }, 5000);
    //     }else{
    //       this.trackerObj=[];
    //       this.loader=false;
    //       this.handler.res('No Data Found')
    //     }

       
    //   },err=>{
    //     this.loader = false;
    //     this.handler.err(err)
    //   }) 
    // }
    // if(this.auth.checkCapability('SC') && !this.auth.checkCapability('SP')){
    //   k=1;
    //   this.conId = localStorage.getItem('currentUserId')
    //   this.service.getServiceTrackerCountByCon(this.cateId,this.conId,start,end).subscribe((res:any)=>{
    //     this.count =res;
    //   })
    //   this.service.monthlyTrackerConBypage(this.cateId,this.conId,start,end,k).subscribe((res:any)=>{
    //     if(res){
    //       this.items = res;
    //       this.items.map(res=>{
    //         this.trackerObj.push(res.singleServicesTracker)
    //       })
    //       this.trackerObj.map(res1=>{
    //        Object.assign(res1,{clicked: false,cusName:res1[0].custName,packId:res1[0].packageId,street:res1[0].street,flatName:res1[0].flatName})
    //        res1.map(res2=>{
    //         res2.serviceTracker.sort((a, b) => new Date(a.apptDate).getTime() - new Date(b.apptDate).getTime());
    //       })
    //       })
    //       this.dubTrackObj = this.trackerObj;     
    //       k++;        
    //      setTimeout(() => {
    //       this.loader=false;
    //      }, 5000);
    //     }else{
    //       this.trackerObj=[];
    //       this.loader=false;
    //       this.handler.res('No Data Found')
    //     }

       
    //   },err=>{
    //     this.loader = false;
    //     this.handler.err(err)
    //   })   
    // }
  }
  
  returnDate(data) {
    let date = data.getDate();
    date = date < 10 ? '0' + date : date;
   let month = data.getMonth() + 1;
   month = month < 10 ? '0' + month : month;
   let year = data.getFullYear();
   return year + '-' + month + '-' + date;
 }


 openPop(data) {
  this.serviceInc = true
  this.pName = data.services[0].name;
  this.pColor = data.custItems[0].colour;
  this.pMake = data.custItems[0].make;
  this.pModel = data.custItems[0].model;
  this.pIdentity = data.custItems[0].identificationNo;
  this.spName = data.employee?.firstName;
}


getCust(val) { 
  let x = val.length;
  if(x > 0){  
    this.close=true;
    this.contractorId="";
    this.contName="";
    this.filterPop=false;
    this.filter=false;
    var start = this.returnDate(this.startdate) + ' ' + '00:00:00';
    var end = this.returnDate(this.enddate) + ' ' + '23:59:59';
    if(this.auth.checkCapability('FSA')){
   this.service.searchCustNumber(this.cateId,start,end,val).subscribe((res: any) => {
     if(res != null && res != "NO_CONTENT" && res.length > 0){ 
      this.trackerObj =[];
      this.items = res;      
      this.items.map(res=>{
        this.trackerObj.push(res.singleServicesTracker)
      })
      this.trackerObj.map(res1=>{
       Object.assign(res1,{clicked: false,cusName:res1[0].custName,packId:res1[0].packageId,packName:res1[0].packageName,street:res1[0].street,flatName:res1[0].flatName})
       res1.map(res2=>{
        res2.serviceTracker.sort((a, b) => new Date(a.apptDate).getTime() - new Date(b.apptDate).getTime());
      })
      })
      this.count = this.trackerObj.length; 
      if(this.custName == "" || this.custName == undefined){
        this.trackerObj=this.dubTrackObj;
        this.close=false;     
      } 
     }else{
       this.trackerObj=[];
       this.items = [];
       this.count=0;
     }      
   })
  }else{
    this.trackerObj=this.dubTrackObj;
    this.items=[]; 
    
  }

  if(this.auth.checkCapability('SP') && !this.auth.checkCapability('FSA')){   
    this.service.monthlyTrackerOtherOrgBypageSearch(this.cateId,this.orgId,start,end,val).subscribe((res:any)=>{
      if(res){
        this.items = res;
        this.items.map(res=>{
          this.trackerObj.push(res.singleServicesTracker)
        })
        this.trackerObj.map(res1=>{
         Object.assign(res1,{clicked: false,cusName:res1[0].custName,packId:res1[0].packageId,packName:res1[0].packageName,street:res1[0].street,flatName:res1[0].flatName})
         res1.map(res2=>{
          res2.serviceTracker.sort((a, b) => new Date(a.apptDate).getTime() - new Date(b.apptDate).getTime());
        })
        })
        this.count = this.trackerObj.length;  
        if(this.custName == "" || this.custName == undefined){
          this.trackerObj=this.dubTrackObj;
          this.close=false;     
        } 
       }else{
         this.trackerObj=[];
         this.items = [];
         this.count=0;
       }      
     })
    }else{
      this.trackerObj=this.dubTrackObj;
      this.items=[];    
    }
  
  if(this.auth.checkCapability('SC') && !this.auth.checkCapability('SP') && !this.auth.checkCapability('FSA')){   
   
    this.service.monthlyTrackerConBypageSearch(this.cateId,this.conId,start,end,val).subscribe((res:any)=>{
      if(res){
        this.items = res;
        this.items.map(res=>{
          this.trackerObj.push(res.singleServicesTracker)
        })
        this.trackerObj.map(res1=>{
         Object.assign(res1,{clicked: false,cusName:res1[0].custName,packId:res1[0].packageId,packName:res1[0].packageName,street:res1[0].street,flatName:res1[0].flatName})
         res1.map(res2=>{
          res2.serviceTracker.sort((a, b) => new Date(a.apptDate).getTime() - new Date(b.apptDate).getTime());
        })
        })
        this.count = this.trackerObj.length;  
        if(this.custName == "" || this.custName == undefined){
          this.trackerObj=this.dubTrackObj;
          this.close=false;
             } 
       }else{
         this.trackerObj=[];
         this.items = [];
         this.count=0;
       }      
     })
    }else{
      this.trackerObj=this.dubTrackObj;
      this.items=[];      
    }
  
}

}





searchCust(id){
  this.router.navigate(['/single-request-In']);
  sessionStorage.setItem('subscriptionId',id)
}

refreshData(event) {
  this.ionViewWillEnter();
  setTimeout(() => {
    event.target.complete();
  }, 1000);
}

openBottomSheet() {
  const dialogRef = this.bottomSheet.open(BottomSheet, {
    data: this.category,
  });

  dialogRef.afterDismissed().subscribe((res:any) => {
    if (res) {
      this.cateName = res.name;
      this.cateId = res.id; 
      // this.loader=true;
      this.custName="";
      this.getsc1();
      var start = this.returnDate(this.startdate) + ' ' + '00:00:00';
      var end = this.returnDate(this.enddate) + ' ' + '23:59:59';  
      // if(this.auth.checkCapability('FSA')){
      //   this.service.getServiceTrackerCount(this.cateId,start,end).subscribe((res:any)=>{
      //     this.count =res;
      //   })
      //   this.service.monthlyTrackerByPage(this.cateId,start,end,k).subscribe((res:any)=>{
      //     if(res){
      //       this.items = res;      
      //       this.items.map(res=>{
      //         this.trackerObj.push(res.singleServicesTracker)
      //       })         
      //       this.trackerObj.map(res1=>{
      //        Object.assign(res1,{clicked: false,cusName:res1[0].custName,packId:res1[0].packageId,street:res1[0].street,flatName:res1[0].flatName})
      //        res1.map(res2=>{
      //         res2.serviceTracker.sort((a, b) => new Date(a.apptDate).getTime() - new Date(b.apptDate).getTime());
      //       })
      //       })
      //       this.dubTrackObj = this.trackerObj;     
      //       k++;        
      //      setTimeout(() => {
      //       this.loader=false;
      //      }, 5000);
           
      //     }else{
      //       this.trackerObj=[];
      //       this.loader=false;
      //       this.handler.res('No Data Found')
      //     }
      //     },
      //   err=>{
      //     this.loader = false;
      //     this.handler.err(err)
      //   })
      // } 
      // if(this.auth.checkCapability('SP') && !this.auth.checkCapability('FSA')){
      //   k=1;
      //   this.service.getServiceTrackerCountByOrg(this.cateId,this.orgId,start,end).subscribe((res:any)=>{
      //     this.count =res;
      //   })
      //   this.service.monthlyTrackerOtherOrgBypage(this.cateId,this.orgId,start,end,k).subscribe((res:any)=>{
      //     if(res){
      //       this.items = res;     
      //       this.items.map(res=>{
      //         this.trackerObj.push(res.singleServicesTracker)
      //       })
      //       this.trackerObj.map(res1=>{
      //        Object.assign(res1,{clicked: false,cusName:res1[0].custName,packId:res1[0].packageId,street:res1[0].street,flatName:res1[0].flatName})
      //        res1.map(res2=>{
      //         res2.serviceTracker.sort((a, b) => new Date(a.apptDate).getTime() - new Date(b.apptDate).getTime());
      //       })
      //       })
      //       this.dubTrackObj = this.trackerObj;    
      //       k++;        
      //      setTimeout(() => {
      //       this.loader=false;
      //      }, 5000);
      //     }else{
      //       this.trackerObj=[];
      //       this.loader=false;
      //       this.handler.res('No Data Found')
      //     }
 
         
      //   },err=>{
      //     this.loader = false;
      //     this.handler.err(err)
      //   }) 
      // }
      // if(this.auth.checkCapability('SC') && !this.auth.checkCapability('SP')){
      //   k=1;
      //   this.conId = localStorage.getItem('currentUserId')
      //   this.service.getServiceTrackerCountByCon(this.cateId,this.conId,start,end).subscribe((res:any)=>{
      //     this.count =res;
      //   })
      //   this.service.monthlyTrackerConBypage(this.cateId,this.conId,start,end,k).subscribe((res:any)=>{
      //     if(res){
      //       this.items = res;     
      //       this.items.map(res=>{
      //         this.trackerObj.push(res.singleServicesTracker)
      //       })
      //       this.trackerObj.map(res1=>{
      //        Object.assign(res1,{clicked: false,cusName:res1[0].custName,packId:res1[0].packageId,street:res1[0].street,flatName:res1[0].flatName})
      //        res1.map(res2=>{
      //         res2.serviceTracker.sort((a, b) => new Date(a.apptDate).getTime() - new Date(b.apptDate).getTime());
      //       })
      //       })
      //       this.dubTrackObj = this.trackerObj;      
      //       k++;        
      //      setTimeout(() => {
      //       this.loader=false;
      //      }, 5000);
      //     }else{
      //       this.trackerObj=[];
      //       this.loader=false;
      //       this.handler.res('No Data Found')
      //     }
 
         
      //   },err=>{
      //     this.loader = false;
      //     this.handler.err(err)
      //   })   
      // } 
    }
  });
}
getsc1(){
  if(this.auth.checkCapability('SP')&& !this.auth.checkCapability('FSA')){
    this.service.getUsersByOrg('SC', this.orgId,null).subscribe((res:any) => { 
      this.contractors=res; 
      this.contractors.map(res=>{
        if(res.categoryLists)
        res.categoryLists.map(res1=>{       
         if(res1.categoryId == this.cateId){
         this.cate1Id = res1.categoryId
         Object.assign(res,{vId:this.cate1Id})       
         }
        })
      })
      this.contractors= this.contractors.filter(res =>{return  res.vId==this.cateId });
      // this.contractors= this.contractors.filter(res =>{return res.reqRoleApproved==true && res.vId==this.cateId }); 
  },err=>{
  this.handler.err(err)
  }) 
  }
  if(this.auth.checkCapability('FSA')){
    this.service.getUsers('SC').subscribe((res:any) => { 
      this.contractors=res;  
      this.contractors.map(res=>{
        if(res.categoryLists)
        res.categoryLists.map(res1=>{       
         if(res1.categoryId == this.cateId){
         this.cate1Id = res1.categoryId
         Object.assign(res,{vId:this.cate1Id})       
         }
        })
      })
      this.contractors= this.contractors.filter(res =>{return  res.vId==this.cateId });
      // this.contractors= this.contractors.filter(res =>{return res.reqRoleApproved==true && res.vId==this.cateId });
  },err=>{
  this.handler.err(err)
  })
  }
}

openBottomSheetCon() {
  const dialogRef = this.bottomSheet.open(BottomSheet, {
    data: this.contractors,
  });
  dialogRef.afterDismissed().subscribe((res) => {
    this.contractorId = res.userId;
    if(res.lastName)
    this.contName = res.firstName ;
    else
    this.contName = res.firstName;
  });
  

}




triggerChange(data,id) {
  if (this.send) {
      data.clicked = !data.clicked;
      if(data.clicked){
        this.notifyItems.push(data);
      } else{
        this.notifyItems=this.notifyItems.filter(res=>res.packId!=data.packId)
      } 

    }
}

click(){
  console.log(this.array.slice(-1).pop())

}

notify(){
  this.trackerObj.map(res=>
    res.clicked=false)

  if(!this.send){
    this.send = true;
  }else{
    this.send = false;
  }

  if(!this.check){
    this.check = true;
  }else{
    this.check = false;
  }
}

sendReq(){
  if(this.notifyItems.length > 0){
    sessionStorage.setItem('notify', JSON.stringify(this.notifyItems))
    this.send = false;      
    this.check = false;
    this.router.navigate(['/group-On-Demand1']) 
  }else{
    this.handler.res("Please Select Cards To Continue")
  }  

}

ionViewWillLeave(){
  this.trackerObj=[]
  this.custName="";
  this.close=false;
}

clear(){
  this.custName="";
  this.close=false;
  this.trackerObj=this.dummyItems;
  var start = this.returnDate(this.startdate) + ' ' + '00:00:00';
  var end = this.returnDate(this.enddate) + ' ' + '23:59:59';
  this.cateId=21;  
  if(this.auth.checkCapability('FSA')){
    this.service.getServiceTrackerCount(this.cateId,start,end).subscribe((res:any)=>{
      this.count =res;
    })
  }
  if(this.auth.checkCapability('SP') && !this.auth.checkCapability('FSA')){
    k=1;
    this.service.getServiceTrackerCountByOrg(this.cateId,this.orgId,start,end).subscribe((res:any)=>{
      this.count =res;
    })
  }
  if(this.auth.checkCapability('SC') && !this.auth.checkCapability('SP') && !this.auth.checkCapability('FSA')){   
    k=1;
    this.service.getServiceTrackerCountByCon(this.cateId,this.conId,start,end).subscribe((res:any)=>{
      this.count =res;
    })
  }

}

monthlyBypage($event){
  if(this.custName == "" || this.custName == undefined){
    if(!this.filter){
    this.clear();
    var start = this.returnDate(this.startdate) + ' ' + '00:00:00';
    var end = this.returnDate(this.enddate) + ' ' + '23:59:59';
    this.cateId=21; 
    if(this.auth.checkCapability('FSA')){
      this.service.getServiceTrackerCount(this.cateId,start,end).subscribe((res:any)=>{
        this.count =res;
      })
      this.service.monthlyTrackerByPage(this.cateId,start,end,k).subscribe((res:any)=>{
        if(res){
         res.map(dat=>{
           this.trackerObj.push(dat.singleServicesTracker)
         })
          this.trackerObj.map(res1=>{
           Object.assign(res1,{clicked: false,cusName:res1[0].custName,packId:res1[0].packageId,packName:res1[0].packageName,street:res1[0].street,flatName:res1[0].flatName})
           res1.map(res2=>{
            res2.serviceTracker.sort((a, b) => new Date(a.apptDate).getTime() - new Date(b.apptDate).getTime());
          })
          })
          this.dubTrackObj = this.trackerObj;
          k++;        
         setTimeout(() => {
          this.loader=false;
         }, 5000);
         
        }else{
          this.trackerObj=[];
          this.loader=false;
          this.handler.res('No Data Found')
        }
        },
      err=>{
        this.loader = false;
      })
    }  
    if(this.auth.checkCapability('SP') && !this.auth.checkCapability('FSA')){
      this.service.getServiceTrackerCountByOrg(this.cateId,this.orgId,start,end).subscribe((res:any)=>{
        this.count =res;
      })
      this.service.monthlyTrackerOtherOrgBypage(this.cateId,this.orgId,start,end,k).subscribe((res:any)=>{
        if(res){
          res.map(dat=>{
            this.trackerObj.push(dat.singleServicesTracker)
          })
          this.trackerObj.map(res1=>{
           Object.assign(res1,{clicked: false,cusName:res1[0].custName,packId:res1[0].packageId,packName:res1[0].packageName,street:res1[0].street,flatName:res1[0].flatName})
           res1.map(res2=>{
            res2.serviceTracker.sort((a, b) => new Date(a.apptDate).getTime() - new Date(b.apptDate).getTime());
          })
          })
          this.dubTrackObj = this.trackerObj;
          k++;        
         setTimeout(() => {
          this.loader=false;
         }, 5000);
        }else{
          this.trackerObj=[];
          this.loader=false;
          this.handler.res('No Data Found')
        }
  
       
      },err=>{
        this.loader = false;
      }) 
    } 
    if(this.auth.checkCapability('SC') && !this.auth.checkCapability('SP')){
      this.service.getServiceTrackerCountByCon(this.cateId,this.conId,start,end).subscribe((res:any)=>{
        this.count =res;
      })
      this.service.monthlyTrackerConBypage(this.cateId,this.conId,start,end,k).subscribe((res:any)=>{
        if(res){
          res.map(dat=>{
            this.trackerObj.push(dat.singleServicesTracker)
          })
          this.trackerObj.map(res1=>{
           Object.assign(res1,{clicked: false,cusName:res1[0].custName,packId:res1[0].packageId,packName:res1[0].packageName,street:res1[0].street,flatName:res1[0].flatName})
           res1.map(res2=>{
            res2.serviceTracker.sort((a, b) => new Date(a.apptDate).getTime() - new Date(b.apptDate).getTime());
          })
          })
          this.dubTrackObj = this.trackerObj;
          k++;        
         setTimeout(() => {
          this.loader=false;
         }, 5000);
        }else{
          this.trackerObj=[];
          this.loader=false;
          this.handler.res('No Data Found')
        }
  
       
      },err=>{
        this.loader = false;
      }) 
    } 
  }
}
}


getMissedStaticData() {
  this.service.getMissedData().subscribe((res: any) => {
    this.missedData = res;
  })
}


getMissed(id){
  this.missedId = id;
  this.missedCheck = true ;
}

captureImage(id) {
  if (this.platform.ANDROID || this.platform.IOS){
    this.camera.getPicture(this.options).then((imageData:any) => {
      if(imageData){
        let base64Image = 'data:image/jpeg;base64,' + imageData;
        this.clickedImage = base64Image;
        this.NotInPlace(id);
      }else{
        this.blobData(id)
      }     
    }); 
  }else{
    this.blobData(id)
    }
}

blobData(id){
  var xhr = new XMLHttpRequest();       
  xhr.open("GET", "assets/icon/seden.jpeg", true); 
  xhr.responseType = "blob";
  var obj=this;
  xhr.onload = function (e) {
  var reader = new FileReader();
  reader.onload = function(event) {
      var res = event.target.result;
  }
  obj.nBlob = this.response;
  reader.readAsDataURL(obj.nBlob);
  obj.NotInPlace(id);
  };
  xhr.send() 
}

DataURIToBlob(dataURI: string) {
  const splitDataURI = dataURI.split(',')
  const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1]);
  const mimeString = splitDataURI[0].split(':')[1].split(';')[0];
  const ia = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i++)
      ia[i] = byteString.charCodeAt(i)
  return new Blob([ia], { type: mimeString })
}

NotInPlace(id){
this.loader=true;
let y = this.status.find(res => res.name == "NotInPlace");
let a =y.id;
var file
if (this.platform.ANDROID || this.platform.IOS){
   file = this.DataURIToBlob(this.clickedImage)
}else{
   file = this.nBlob;
}
setTimeout(() => {
  this.service.notInPlace(id,a,file).subscribe((res:any)=>{
    sessionStorage.setItem("clickValue",id)
    this.handler.res('Status Updated Successfully !!');
    this.trackerObj=[];
    this.clear();
     },
  err=>{
    this.loader=false;
    this.handler.err(err)
  })
}, 1000);

}

getImage(id){
this.loader = true;
this.service.getDocumentImg(id).subscribe(res=>{  
     this.popImg= this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(res));
     this.imgView = true;
     this.loader = false;
   },err =>{
     this.loader = false;
     this.handler.err(err); 
   })
}

closePop(){
this.imgView=false;
this.popImg = undefined;
}

clearArray(value){
  this.changeId=value.id;
}

clearArray1(value){
  this.missedValue=value.id;
}


Missed(){
  let y = this.status.find(res => res.name == "Missed");
  let a =y.id;
  let post = {
    "id":this.missedId,
    "status": a,
    "missedReasons":this.missedValue
    }
  this.service.missed(post ,this.missedId).subscribe((res:any)=>{
    this.handler.res('Status Updated Successfully !!')
    this.missedCheck=false;
    this.trackerObj=[];
    this.clear();
    
  },
  err=>{
    this.loader=false;
    this.handler.err(err)
  })
}

getDailyStatus(){
  this.service.getDailyStatus().subscribe(res =>{ 
    this.status = res;  
 }) 
}

Completed(id){
  let y = this.status.find(res => res.name == "Completed");
  let a =y.id;
  let post = {
    "id":id,
    "status": a,
   }
     this.service.completed(post,id).subscribe((res:any)=>{
    this.handler.res('Status Updated Successfully !!')
    this.trackerObj=[];
    this.clear();
  },
  err=>{
    this.loader=false;
    this.handler.err(err)
  })
}

getReason(id){
  this.resId=id;
  this.ChangeInc=true;
}

getChange(){
  this.service.getReasons().subscribe(res =>{ 
    this.reasons = res;
  }) 
}

updateReason(){
  let post = {
    "id":this.resId,
    "status": 2,
    "reason":this.changeId  
  }
  this.service.updateReasons(post,this.resId).subscribe((res:any)=>{
    this.handler.res('Status Updated Successfully !!')
    this.clear();
  },
  err=>{
    this.loader=false;
    this.handler.err(err)
  }) 
}
clearCapture(){
  this.clickedImage = ""
  this.ChangeInc = false;
  this.updateReason();
}



openBottomSheetActions(id,data){
  if(data == 2){
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.actionObj,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.actionName = res.name;
        this.actionId = res.id;  
           }
           if(this.actionId==1){
            this.getMissed(id);
          }
          if(this.actionId==2){
            // this.NotInPlace(id);
            this.captureImage(id) 
          }
          if(this.actionId==3){
            this.Completed(id);
          }
          if(this.actionId==4 && (data==3 || data==7 || data==8 )){
            this.getReason(id);
          }
    });
  }else{
    this.handler.res("Request is not Confirmed")
  }
}


searchfilter1(){
  this.filter = true;
  this.trackerObj=[];
  var start = this.returnDate(this.startdate) + ' ' + '00:00:00';
  var end = this.returnDate(this.enddate) + ' ' + '23:59:59';
  var post = [{id:1,val:this.cateId,cateId:true,data:"categoryId"},
    {id:2,val:start,rgId:true,data:"fromDate"},
    {id:3,val:this.contractorId,contractorId:true,data:"serviceContractorId"},
    {id:4,val:end,statusId:true,data:"toDate"}]
 var y = post.filter(res=>{return res.val != undefined })
  if(y.length == 3){
    this.loader = true;
    this.service.monthlyTrackerByPageFilter1(y[0].data,y[1].data,y[2].data,y[0].val,y[1].val,y[2].val).subscribe((res:any)=>{
      if(res){
        this.items = res;
        this.items.map(res=>{
          this.trackerObj.push(res.singleServicesTracker)
        })
        this.trackerObj.map(res1=>{
         Object.assign(res1,{clicked: false,cusName:res1[0].custName,packId:res1[0].packageId,packName:res1[0].packageName,street:res1[0].street,flatName:res1[0].flatName})
         res1.map(res2=>{
          res2.serviceTracker.sort((a, b) => new Date(a.apptDate).getTime() - new Date(b.apptDate).getTime());
        })
        })
        this.count=this.trackerObj.length;
        this.dubTrackObj = this.trackerObj;
      setTimeout(() => {
        this.loader=false;
       }, 5000);
      }else{
        this.loader=false;
        this.trackerObj=[];
        this.count=0;
        this.handler.res("No Data Found");
      }
    }, err => {
      this.loader = false;
      this.filterPop = true;
      this.handler.err(err);
    })
  }
  if(y.length == 4){
    this.loader = true;
    this.service.monthlyTrackerByPageFilter2(y[0].data,y[1].data,y[2].data,y[3].data,y[0].val,y[1].val,y[2].val,y[3].val).subscribe((res:any)=>{
      if(res){
        this.items = res;
        this.items.map(res=>{
          this.trackerObj.push(res.singleServicesTracker)
        })
        this.trackerObj.map(res1=>{
         Object.assign(res1,{clicked: false,cusName:res1[0].custName,packId:res1[0].packageId,packName:res1[0].packageName,street:res1[0].street,flatName:res1[0].flatName})
         res1.map(res2=>{
          res2.serviceTracker.sort((a, b) => new Date(a.apptDate).getTime() - new Date(b.apptDate).getTime());
        })
        })
        this.dubTrackObj = this.trackerObj;
        this.count=this.trackerObj.length;
       setTimeout(() => {
        this.loader=false;
       }, 5000);
      }else{
        this.loader=false;
        this.trackerObj=[];
        this.count=0;
        this.handler.res("No Data Found");
      }
    }, err => {
      this.loader = false;
      this.filterPop = true;
      this.handler.err(err);
    })
  }
   
}

cancelFilter() {
  this.loader = true;
  this.contractorId = "";
  this.contName = ""; 
  this.filterPop = false;
  this.filter = false;
  this.ionViewWillEnter();
}

  
filterReq(){
  this.filterPop = true;
}

}